// Datos legales centralizados de la entidad responsable de levellocal
export const LEGAL = {
  brand: "Level Local",
  company: "Luxury Holidays, S.L.",
  cif: "B93277366",
  address: "Calle Río Darro S/N, portal 1, puerta 20",
  postalCode: "29651",
  city: "Mijas",
  province: "Málaga",
  country: "España",
  email: "contabilidad@impresiona.net",
  contactEmail: "hola@levellocal.com",
  phone: "+34 663 26 68 80",
  phoneRaw: "34663266880",
  whatsappMessage: "Hola, me interesa Level Local",
  website: "https://levellocal.lovable.app",
  registry:
    "Registro Mercantil de Málaga (datos de inscripción disponibles a solicitud del interesado)",
  notary:
    "Constituida ante el Notario D. Carlos Bianchi Ruiz del Portal el 28 de agosto de 2013, escritura nº 1908 de su protocolo",
  lastUpdate: "20 de abril de 2026",
  // URL pública para reservar demos (Cal.com recomendado, sincroniza con Google Calendar).
  // Cambia este valor cuando tengas tu cuenta creada en cal.com.
  demoBookingUrl: "https://cal.com/levellocal/demo",
};
